import { BoardsTeacherInfo } from '@descomplica/dex-models';

export interface BoardsTeacherState {
  boardsTeachers: { [key: string]: BoardsTeacherInfo };
}

const state: BoardsTeacherState = {
  boardsTeachers: {},
};

export default state;
